import { render } from "./Elections.vue?vue&type=template&id=0a5d627a&ts=true"
import script from "./Elections.vue?vue&type=script&lang=ts"
export * from "./Elections.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__